module.exports = __webpack_public_path__ + "img/download-apple.4a015be0.png";